<span class="interactive"></span>
<svg (selectstart)="$event.preventDefault()" (mousedown)="$event.preventDefault()" [icon]="icon" class="dark-gray-color"/>
